"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import SourceCard from "@/app/(components)/generics/cards/SourceCard/SourceCard";
import IconSparkles from "@/app/(components)/generics/Icons/IconSparkles";
import { useAuthUser } from "@/app/(components)/specifics/wrappers/AuthProvider/AuthProvider";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { URLs } from "@/app/utils/URLs";
import { Routes } from "@/app/vars/Routes";

export default function GenerateAvatarWithAi(props: DefaultProps) {
  const T = useT();
  const { params } = props;

  const user = useAuthUser();

  return (
    <SourceCard
      icon={<IconSparkles size={26} />}
      title={T(TKey.CLIENT_AVATAR_GENERATE_TITLE) as string}
      badge={T(TKey.CLIENT_AVATAR_GENERATE_BADGE) as string}
      description={T(TKey.CLIENT_AVATAR_GENERATE_DESCRIPTION) as string}
      benefits={[
        T(TKey.CLIENT_AVATAR_GENERATE_BENEFIT_1) as string,
        T(TKey.CLIENT_AVATAR_GENERATE_BENEFIT_2) as string,
        T(TKey.CLIENT_AVATAR_GENERATE_BENEFIT_3) as string,
      ]}
      actions={
        <Button
          min={true}
          isLink={!!user}
          href={user ? URLs.pathOf(Routes.MCP_GUIDE) : undefined}
          type={ButtonType.PRIMARY}
          text={T(TKey.CLIENT_AVATAR_GENERATE_CTA) as string}
          onClick={user ? undefined : () => ModalStore.getState().openSignUp(params)}
        />
      }
    />
  );
}
